import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import { ShopType } from "src/types/graphql.d";

interface BrandSEO {
  brandSEO: {
    leftColumnHTML: string | null;
    rightColumnHTML: string | null;
  };
}

interface BrandSEOResponse {
  data: BrandSEO | undefined;
  loading: boolean;
  error?: ApolloError;
}

interface BrandSEOVariables {
  brand_slug: string;
  shop_type: ShopType;
}

const GET_BRAND_SEO = gql`
  query BrandSEO($brand_slug: String!, $shop_type: ShopType!) {
    brandSEO(brand_slug: $brand_slug, shop_type: $shop_type) {
      leftColumnHTML
      rightColumnHTML
    }
  }
`;

const useBrandSEO = ({
  brand_slug,
  shop_type,
}: BrandSEOVariables): BrandSEOResponse => {
  const { data, loading, error } = useQuery<BrandSEO, BrandSEOVariables>(
    GET_BRAND_SEO,
    {
      variables: {
        brand_slug,
        shop_type,
      },
      ssr: true,
      fetchPolicy: "cache-first",
      skip: !brand_slug || !shop_type,
    }
  );

  return {
    data,
    loading,
    error,
  };
};

export default useBrandSEO;
